import React, { useEffect, useState } from "react"
import {EColor, EIconGlyph, ESize} from "../../styleConstants"
import PageWrapper from "../Blocks/pageWrapper"
import { rem } from "../styleUtils"
import FriendReferralHero from "./referalHero"
import Icon from "../Blocks/icon";
import styled from "styled-components"

interface IReferAFriendData {
    referralLink?: string
    referralId?: string
    tag?: string
}

const ExpandOverlay = styled.div`
  background: linear-gradient(to bottom, transparent 0%, black 100%);
  position: absolute;
  bottom: 0;
  height: 100px;
  right: 0;
  left: 0;
  cursor: pointer;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 15px;
`;

export default function FriendReferralCompact ({

}: {

}) {
    const [data, setData] = useState<IReferAFriendData>({})
    const [expanded, setExpanded] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            const response = await fetch(`/accounts/refer_friend.json`)
            const data = await response.json() as IReferAFriendData
            setData(data)
        }
        fetchData()
    }, [])

    if (expanded && data.referralId) {
      return (
        <div style={{borderRadius: rem(15), overflow: "hidden", marginBottom: rem(ESize.medium)}}>
          <PageWrapper>
            <FriendReferralHero referralId={data.referralId} referralLink={data.referralLink} tag={data.tag} linkHowItWorks={true} />
          </PageWrapper>
        </div>
      )
    }  else if (data.referralId) {
        return (
          <div style={{borderRadius: rem(15), overflow: "hidden", marginBottom: rem(ESize.medium)}}>
            <div style={{ height: 250, position: "relative" }}>
              <PageWrapper>
                <FriendReferralHero referralId={data.referralId} referralLink={data.referralLink} tag={data.tag} linkHowItWorks={true} />
              </PageWrapper>
              <ExpandOverlay
                onClick={() => setExpanded(true)}
              >
                <Icon icon={EIconGlyph.chevron_down} size={ESize.default} color={EColor.FloralWhite}  />
              </ExpandOverlay>
            </div>
          </div>
        )
    } else {
        return ( <div></div> )
    }
}
